import api from "@/services/api";
import {
    Authorization,
    AuthorizationInfo
} from "@/services/authorizations/types";

export async function getAllAuthorizations(): Promise<Array<Authorization>> {
    return new Promise((resolve, reject) => {
        api.get("/OAuth").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAuthorization(id: string): Promise<Authorization> {
    return new Promise((resolve, reject) => {
        api.get(`/OAuth/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAuthorizationInfo(id: string): Promise<AuthorizationInfo> {
    return new Promise((resolve, reject) => {
        api.get(`/OAuth/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getRedirectUri(): Promise<string> {
    return new Promise((resolve, reject) => {
        api.get(`/OAuth/RedirectUri`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function createAuthorization(authorization: Authorization) : Promise<string> {
    return new Promise((resolve, reject) => {
        api.post(`/OAuth`, authorization).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function updateAuthorization(authorization: Authorization) : Promise<void> {
    return new Promise((resolve, reject) => {
        api.put(`/OAuth`, authorization).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function deleteAuthorization(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.delete(`/OAuth/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAccessToken(param: string): Promise<string> {
    return new Promise((resolve, reject) => {
        api.get(`/OAuth/getAccessToken/${param}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function authorize(id: string) : Promise<boolean> {
    return new Promise((resolve, reject) => {
        api.post(`/OAuth/authorize/${id}`, {}).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getOAuthJwtToken(id: string): Promise<string> {
    return new Promise((resolve, reject) => {
        api.get(`/OAuth/getOAuthJwtToken/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
